import ActionTypeContrato from "../ActionTypeContrato";
import {ModosOp} from '../../../../isp._comun/iu/_principal/constantesIuPrin'// import Estado from '../../EstadoDialogoClienteAFacturar'

export default class CargaDeContratoRegistrado extends ActionTypeContrato {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.domain.screen.idItem = this.payload.idItem;
        nuevoEstado.domain.screen.fechaReg = this.payload.fechaReg;
        nuevoEstado.domain.screen.estado = this.payload.estado;
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.flag.modoOperacion = ModosOp.OK;

        for (const property in estado.error) {
            nuevoEstado.error[property] = false;
        }

        nuevoEstado.domain.cargado = JSON.parse(JSON.stringify(estado.domain.screen));
        delete nuevoEstado.domain.cargado.idCliente;
        delete nuevoEstado.domain.cargado.fechaReg;
        delete nuevoEstado.domain.cargado.estado;
        nuevoEstado.domain.update = {};
        nuevoEstado.domain.nroUpdates = 0;

        return nuevoEstado;
    }
}
